import './ButtonPrimary.css';

export default function ButtonPrimary({
    txt = "Example",
    onClick = () => null,
    width = '',
    disable=false
}) {
    return <button
    disabled={disable}
    style={{width: width}}
     onClick={onClick} 
     className={disable?'AppButtonPrimary_disable':'AppButtonPrimary'}
     >{txt}</button>
}